import { CAL_BOOK_20MIN_URL } from "../../../config/links";
import styles from "./CustomIntegrationTile.module.css";

export const CustomIntegrationTile = (): JSX.Element => (
  <a
    className={styles.tile}
    href={CAL_BOOK_20MIN_URL}
    target="_blank"
    rel="noreferrer noopener"
    aria-label="Request a custom integration"
  >
    <h3 className={styles.title}>Need a custom integration?</h3>
    <p className={styles.subtitle}>
      We'll build the connector. Book a 20-min scoping call.
    </p>
    <span className={styles.cta}>
      Book a call
      <span className={styles.arrow} aria-hidden>
        →
      </span>
    </span>
  </a>
);
